import React from 'react'
import { Route } from 'react-router-dom'

interface IProps {
  exact?: boolean
  strict?: boolean
  path: string | string[]
  date?: string
  component: React.ComponentType<any>
  children?: React.ReactNode
}

const NonProtectedRoute = ({
  path,
  exact,
  strict,
  date,
  component: Component,
  children
}: IProps) => {
  return (
    <Route
      exact={exact}
      strict={strict}
      path={path}
      component={(props) => (
        <Component {...props} {...(date ? { date } : {})}>
          {children}
        </Component>
      )}
    />
  )
}

export default NonProtectedRoute
